module.exports = __webpack_public_path__ + "static/icons/person-start.8d66265.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nps/person-start.svg
// module id = Gh1g
// module chunks = 1